<template>
  <div class="w-100">
    <a
      href="#"
      @click="returnToOverview"
    > zurück zur Benutzerverwaltung </a>
    <br>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
    />
    <v-flex
      v-else-if="isLoading"
      justify-center
    >
      <u-loader />
    </v-flex>
    <template v-else>
      <div class="form-group mb-4">
        <b-container class="settingsPanel">
          <div class="settingsPanelHeader">
            Stammdaten
          </div>
          <b-row class="">
            <label class="mt-2 col-3 defaultLabel"> Benutzername </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="usernameInput"
                v-model="userObject.email"
                disabled
              />
            </div>
          </b-row>
          <b-row class="mt-0">
            <label class="mt-4 col-3 defaultLabel"> Vorname </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="firstNameInput"
                v-model="userObject.firstName"
              />
            </div>
          </b-row>
          <b-row class="mt-0">
            <label class="mt-4 col-3 defaultLabel"> Nachname </label>
            <div class="col-6 pl-0">
              <v-text-field
                id="surNameInput"
                v-model="userObject.lastName"
              />
            </div>
          </b-row>
        </b-container>
      </div>
      <div class="form-group mb-4">
        <b-container class="settingsPanel">
          <div class="settingsPanelHeader">
            Rollen &amp; Berechtigungen
          </div>
          <b-row class="">
            <label class="mt-4 col-3 defaultLabel"> Rollen </label>
            <div class="col-6 pl-0">
              <v-select
                id="presetSelect"
                v-model="selectedPreset"
                :items="presets"
                item-text="name"
                item-value="name"
                clearable
                placeholder="Berechtigung mittels Preset setzen"
                @change="applyPreset"
              />
            </div>
          </b-row>
          <b-row class="mt-4">
            <label class="col-3 defaultLabel"> Berechtigungen </label>
            <div class="col-9 pl-0 checkboxControl">
              <div
                v-for="role in roles"
                :key="role"
              >
                <label>
                  <input
                    v-model="userObject.roles"
                    :value="role"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text">{{ role }}</span>
                </label>
              </div>
            </div>
          </b-row>
          <b-row class="mt-4 pt-1">
            <label class="col-3 defaultLabel"> CMS </label>
            <div class="col-9 pl-0 checkboxControl">
              <div
                v-for="role in cmsRoles"
                :key="role"
              >
                <label>
                  <input
                    v-model="userObject.roles"
                    :value="role"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text">{{ role }}</span>
                </label>
              </div>
            </div>
          </b-row>
        </b-container>
      </div>
      <div class="form-group mb-4">
        <b-container class="settingsPanel">
          <div class="settingsPanelHeader">
            Benutzerstatus
          </div>
          <b-row class="mt-4">
            <label class="col-3 defaultLabel"> gesperrt </label>
            <div class="col-9 pl-0">
              <div class="form-check pl-0">
                <label>
                  <input
                    v-model="userObject.locked"
                    name="check"
                    type="checkbox"
                  >
                  <span class="label-text" />
                </label>
              </div>
            </div>
          </b-row>
        </b-container>
      </div>
      <div class="form-group mb-4">
        <b-container class="p-0">
          <button
            class="btn btn-danger smallActionButton float-right"
            placement="bottom"
            title="Löschen"
            @click="deleteUser"
          >
            <i class="fas fa-trash" />
          </button>
          <b-row class="">
            <button
              class="btn btn-success"
              title="Bearbeiten"
              @click="SaveUser"
            >
              Speichern
            </button>
            <button
              class="btn btn-danger ml-2"
              title="Bearbeiten"
              @click="returnToOverview"
            >
              Abbrechen
            </button>
          </b-row>
        </b-container>
      </div>
      <hr>
      <PasswordReset :user-id="userId" />
    </template>
  </div>
</template>

<script>
import PasswordReset from "@/components/UserManagement/PasswordReset.vue";
import {
  DeleteUser,
  GetRoles,
  GetUser,
  UpdateUser,
} from "@/services/user.service.js";

export default {
  components: {
    PasswordReset,
  },
  data() {
    return {
      userObject: null,
      userId: null,
      errorObject: null,
      isLoading: false,
      roles: [],
      cmsRoles: [],
      selectedPreset: null,

      // Each entry maps to the exact role keys used in userObject.roles.
      presetConfigurations: {
        Superuser: [
          "VertragsmanagementVetragsDetails",
          "VertragsmanagementAdministration",
          "VertragsmanagementVerwaltung",
          "VertragsmanagementEinsicht",
          "KonfigurationContentmanager",
          "KlauselauspraegungAdministration",
          "AllgemeinerFeiertagskalenderAdministration",
          "GesetzlicheMindestloehneVerwaltung",
          "ZuschlagsrechnerVerwaltung",
          "ImportMiloKonfig",
          "UeblicherLohnStammdatenAktualisieren",
          "GavserviceContentmanager",
          "UniaContentmanager",
        ],
        "DokuTeam Vertragsmanagement": [
          "VertragsmanagementVetragsDetails",
          "VertragsmanagementAdministration",
          "VertragsmanagementVerwaltung",
          "VertragsmanagementEinsicht",
          "KonfigurationContentmanager",
          "ZuschlagsrechnerVerwaltung",
        ],
        "Unia-GAV-Verantwortliche (inkl. Vollzug)": [
          "VertragsmanagementUniaVertragsverantworlich",
          "VertragsmanagementVerwaltung",
          "VertragsmanagementEinsicht",
        ],
        "Vertragsdetails/-stammdaten pflegen": [
          "VertragsmanagementVerwaltung",
          "VertragsmanagementEinsicht",
        ],
        "Read only (Potentiell alle Unia MA)": [
          "VertragsmanagementEinsicht",
        ],
      },
      rolesDescriptions: {
        VertragsmanagementVetragsDetails: "Vertragsdetails bearbeiten",
        VertragsmanagementUniaVertragsverantworlich:
          "Unia-Vertragsverantwortlich",
        VertragsmanagementAdministration: "Rollen verwalten, Auditlog",
        VertragsmanagementVerwaltung: "Editieren von Verträgen",
        VertragsmanagementEinsicht: "Einsehen von Verträgen",
        KonfigurationContentmanager: "Kontakte usw. verwalten",
        KlauselauspraegungAdministration:
          "Konfigurieren von Klauselausprägungen",
        AllgemeinerFeiertagskalenderAdministration:
          "Konfigurieren allgemeiner Feiertagskalender",
        GesetzlicheMindestloehneVerwaltung:
          "Gesetzliche Mindestlöhne Definieren",
        ZuschlagsrechnerVerwaltung: "Editieren von Zuschlagsrechnern",
          ImportMiloKonfig: "Import von Mindestlohn Konfigurationen",
          UeblicherLohnStammdatenAktualisieren: "Aktualisierung Stammdaten üblicher Lohn"
      },
      cmsDescriptions: {
        GavserviceContentmanager: "Zugriff auf CMS Gavservice",
        UniaContentmanager: "Zugriff auf CMS Uniaservice",
      },
    };
  },
  computed: {
    allRoleDescriptions() {
      return { ...this.rolesDescriptions, ...this.cmsDescriptions };
    },
    presets() {
      return Object.keys(this.presetConfigurations)
        .sort((a, b) => a.localeCompare(b))
        .map((name) => ({ name }));
    },
  },
  created() {
    this.userId = this.$route.params.userId;
    this.LoadUser();
    this.GetRoles();
  },
  methods: {
    formatRole(key) {
      const description = this.allRoleDescriptions[key];
      if (!description) {
        return null;
      }
      return "".concat(
        key.replace(/[A-Z]/g, " $&").trim(),
        " [",
        description,
        "]",
      );
    },
    applyPreset(presetName) {
      const config = this.presetConfigurations[presetName];
      if (!config) {
        return;
      }
      // Overwrite current roles with the preset's roles.
      // The checkbox values are formatted strings (see SplitStringsArray),
      // so raw preset keys must go through the same formatting.
      // User can still manually adjust checkboxes afterwards.
      this.userObject.roles = config
        .map((key) => this.formatRole(key))
        .filter((role) => role !== null);
    },
    deleteUser() {
      DeleteUser(
        this.userId,
        () => {
          this.returnToOverview();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    returnToOverview() {
      this.$router.push({
        path: "/users",
      });
    },
    GetRoles() {
      GetRoles(
        (response) => {
          this.roles = this.SplitStringsArray(response, this.rolesDescriptions);
          this.cmsRoles = this.SplitStringsArray(
            response,
            this.cmsDescriptions,
          );
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    LoadUser() {
      this.errorObject = null;
      this.isLoading = true;

      GetUser(
        this.userId,
        (response) => {
          this.userObject = response;
          this.userObject.roles = this.SplitStringsArray(
            response.roles,
            this.allRoleDescriptions,
          );

          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    SaveUser() {
      this.errorObject = null;
      this.isLoading = true;
      const roles = [];

      this.userObject.roles.forEach((role) => {
        const roleSplit = role.split("[");
        roles.push(roleSplit[0].replace(/\s/g, ""));
      });

      this.userObject.roles = roles;

      UpdateUser(
        this.userId,
        this.userObject,
        () => {
          this.LoadUser();
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    SplitStringsArray(stringsArray = [], descriptions) {
      const strings = [];
      stringsArray.forEach((string) => {
        if (string in descriptions) {
          let roleDescription = descriptions[string];
          if (roleDescription) {
            strings.push(
              "".concat(
                string.replace(/[A-Z]/g, " $&").trim(),
                " [",
                roleDescription,
                "]",
              ),
            );
          }
        }
      });
      return strings;
    },
  },
};
</script>

<style>
.checkboxControl .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

.checkboxControl .v-input--selection-controls__ripple:before {
  content: "\f14a";
  color: red;
  -webkit-animation: effect 250ms ease-in;
  animation: effect 250ms ease-in;
  font-weight: 900;
}
</style>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}

.contactsOverview {
  font-size: small;
  table-layout: fixed;
}

.userOverview thead th:nth-child(6) {
  width: 10%;
}

.userOverview tbody tr {
  border-bottom: 1px solid gainsboro;
}

.userOverview td,
.userOverview th {
  padding: 8px 4px;
}

.settingsPanel {
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 16px 16px 8px;
  background-color: #fafafa;
}

.settingsPanelHeader {
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dee2e6;
}

.actionDivider {
  border: none;
  border-top: 1px solid #dee2e6;
  margin: 16px 0;
}
</style>
